export default __webpack_public_path__ + "static/media/grafema_the-creativity-virus_02.667ec4b0.jpg";